import FormLabel from "./FormLabel";
import FormGroup from "~/components/FormGroup";
import Decimal from "decimal.js";
import NumberFormControl from "~/components/NumberFormControl";
import Button from "~/components/Button";
import { createEffect, createSignal } from "solid-js";
import { PaymentType, paymentType } from "~/mydata";

const PosPayForm = ({ payableAmount, remainingAmt, setPayAmount, paymentStatus, makePayment, paymentMeans, setPayingAmount }: {
  payableAmount: any,
  remainingAmt: string,
  setPayAmount: any,
  paymentStatus: any,
  makePayment: any,
  paymentMeans: any,
  setPayingAmount: any,
}) => {
  const [isDisabled, setIsDisabled] = createSignal(false);

  const handleAmountChange = (event: Event) => {
    const newValue = parseFloat((event.currentTarget as HTMLInputElement).value);
    if (isNaN(newValue)) {
      setPayAmount(0);
    } else {
      setPayAmount(new Decimal(newValue));
    }
  };

  createEffect(() => {
    const pa = parseFloat(payableAmount());
    const ra = parseFloat(remainingAmt);

    if (pa <= 0 || isNaN(pa) || (pa > ra)) {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }

  });

  return (
    <FormGroup style="margin-left: 0 !important">
      <FormLabel style="margin-bottom: 10px !important; width: 100%; text-align: center; padding: 10px !important;">
        Payable Amount
      </FormLabel>
      <NumberFormControl
        type="number"
        min={0}
        max={remainingAmt}
        label="Αριθμός"
        value={parseFloat(payableAmount())}
        onInput={handleAmountChange}
        classList={{
          ["p-2"]: true,
          ["text-center"]: true,
          ["fs-3"]: true
        }}
      />
      <Button
        name="pay"
        type="button"
        disabled={paymentStatus() !== "Pay" || isDisabled() || parseFloat(payableAmount()) === 0} // Disable the button based on isDisabled signal
        kind="primary"
        class="form-control mt-3"
        onClick={() => makePayment()}
      >
        {paymentMeans() === paymentType.POS ? paymentStatus() : "Set Payable Amount"}
      </Button>
    </FormGroup>
  );
};
export default PosPayForm;
